import { Col, Row } from 'antd';
import styled from 'styled-components';

export const SpinnerContainer = styled.div`
  height: 100%;
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExpandedRowContainer = styled(Row)`
  left: 8px;
  position: sticky;
  min-height: 250px;
  /* A media query instead of window.innerWidth: that value is read once at
     module load and goes stale, and browser zoom changes it (zoom changes how
     many CSS pixels the viewport is). */
  width: calc(100vw - 200px - 64px);
  white-space: normal;
  z-index: 1;

  @media (max-width: 991px) {
    width: calc(100vw - 79px - 64px);
  }
`;

export const StyledRow = styled(Row)`
  height: 100%;
`;

export const StyledCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

/**
 * The row above is sized from 100vw, so a percentage-width image would keep the
 * same physical size under browser zoom: zooming out grows the viewport in CSS
 * pixels, and the image grows with it, cancelling the zoom. Sizing in rem makes
 * the image scale like the surrounding text instead. It may still shrink below
 * that when the visible area is narrow.
 */
export const ImageCol = styled(StyledCol)`
  flex: 0 1 22rem;
  max-width: 22rem;
`;

export const DetailsCol = styled(Col)`
  flex: 1 1 0;
  max-width: none;
  min-width: 0;
`;

export const ControlsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  > button,
  > span {
    margin-top: 12px;
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const AttributesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  .ant-btn {
    margin-top: 0.5rem;
    margin-right: 0.5rem;
  }
`;

export const SectionTitle = styled.div`
  color: ${({ theme }) => theme.labelColor};
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;
